module.exports = __webpack_public_path__ + "img/logo.2ec059d7.png";